/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useContext, useEffect, useState } from "react"

import FlexGridOuter from "../../../../components/FlexGridWrapper/FlexGridOuter"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"
import CONSTANT from "../../../../constant"
import { Button } from "react-bootstrap"
import { SearchResultContext } from "./ZyutyuHaisyaPatternModalContext"
// TODO:ダミー
import { T受注配車パターン入力GridItem } from "./ZyutyuHaisyaPatternModal"
import { T表紙分割 } from "../../../../components/ComboBox/HyosiBunkatuComboBox"
import {
  品名Bindings,
  支払Bindings,
  積地Bindings,
  卸地Bindings,
  積卸日Bindings,
  請求Bindings,
  車輌Bindings,
} from "./ZyutyuHaisyaPatternModalConstant"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import { T請求内訳 } from "../../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { GridInitializedContext } from "../../../../components/Context"
import { TZyutyuHaisyaPatternListGetRes } from "../../../../service/order/zyutyuHaisyaPattern/TZyutyuHaisyaPattern"
import BusyoService from "../../../../service/master/busyo/busyoService"
import KubunService from "../../../../service/master/kubun/kubunService"
import NinusiSeikyuService from "../../../../service/master/ninusiseikyu/ninusiSeikyuService"

/**
 * 受注配車入力grid部
 * @param props
 * @returns
 */
const ZyutyuHaisyaPatternModalGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
  setPattern: (value: TZyutyuHaisyaPatternListGetRes) => unknown
}> = (props) => {
  //#region [context]

  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(
    GridInitializedContext
  )

  // 検索結果
  const searchResult = useContext(SearchResultContext)
  //#endregion

  //#region [state]
  //dataMap
  //表紙分割と請求内訳は動的生成
  const [表紙分割DataMap, set表紙分割DataMap] =
    useState<wjcGrid.DataMap<T表紙分割>>()
  const [請求内訳DataMap, set請求内訳DataMap] =
    useState<wjcGrid.DataMap<T請求内訳>>()

  const [運行部所DataMap, set運行部所DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  //区分系
  const [単位区分DataMap, set単位区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [車種区分DataMap, set車種区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [請求区分DataMap, set請求区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T受注配車パターン入力GridItem>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView<T受注配車パターン入力GridItem>(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (積卸日Bindings.includes(c.binding)) {
          setHeaderText = "積卸日"
        } else if (積地Bindings.includes(c.binding)) {
          setHeaderText = "積地"
        } else if (卸地Bindings.includes(c.binding)) {
          setHeaderText = "卸地"
        } else if (品名Bindings.includes(c.binding)) {
          setHeaderText = "品名"
        } else if (車輌Bindings.includes(c.binding)) {
          setHeaderText = "車輌"
        } else if (請求Bindings.includes(c.binding)) {
          setHeaderText = "請求"
        } else if (支払Bindings.includes(c.binding)) {
          setHeaderText = "支払"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        c.align = "left"
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
  }

  //#endregion

  //#region [baseState]

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)
  const [isRestoreSearching, setIsRestoreSearching] = useState(false)
  //アラート制御
  //   const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [effect]

  //初期表示
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      //区分値の確保
      //TODO: APIより区分の一覧を取得し各dataMapにフィルターしながら設定
      set単位区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.マスタ.単位区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set車種区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.車輌.車種区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set請求区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.請求区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set運行部所DataMap(
        new wjcGrid.DataMap(部所ListRes.data, "部所コード", "部所名")
      )
    })
  }, [])

  // 初回表紙分割、請求内訳取得用メソッド
  //TODO
  const 初回荷主請求取得 = async (検索条件: any[]) => {
    const 荷主IdList = 検索条件
      .filter((a) => a.荷主ID != null)
      .map((a) => a.荷主ID as number)
    const 荷主請求IdList = 検索条件
      .filter((a) => a.荷主請求ID != null)
      .map((a) => a.荷主請求ID as number)

    try {
      const res = await new NinusiSeikyuService().getList({
        荷主IdList,
      })

      if (res && res.data) {
        //TODO:実際はAPIより取得
        set表紙分割DataMap(
          new wjcGrid.DataMap([...res.data], "荷主請求ID", "表紙名")
        )
      }
      const 内訳Res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求IdList,
      })
      if (内訳Res && 内訳Res.data) {
        set請求内訳DataMap(
          new wjcGrid.DataMap(内訳Res.data, "荷主請求内訳ID", "請求内訳名")
        )
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (searchResult == null) return
    // 取得したデータより表紙分割と請求内訳を取得
    初回荷主請求取得(searchResult)
    setGridData({ data: createCollectionView(searchResult, pageSize) })

    flexGrid?.refresh()
  }, [searchResult])

  //#endregion

  return (
    <div>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pageNumber={pageNumber}
        searchConditionClear={props.searchConditionClear}
        gridId={props.gridId}
        isRestoreSearching={isRestoreSearching}
        isEnablePageSize={"visible"}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        gridInitializedHandler={gridInitializedHandler}
        gridProperties={{
          frozenColumns: 5,
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.All,
          keyActionTab: wjcGrid.KeyAction.CycleOut,
        }}>
        <wjrGrid.FlexGridColumn
          header="選択"
          allowDragging={false}
          hasFilter={false}
          allowSorting={false}
          binding="受注配車id"
          allowMerging={true}
          align="center"
          width={100}
          selectable={false}
          isReadOnly>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TZyutyuHaisyaPatternListGetRes>
            ) => {
              return (
                <Button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault()
                    props.setPattern(context.item)
                  }}>
                  選択
                </Button>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注配車パターンコード"
          width={128}
          header="パターンCD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注配車パターン名"
          width={200}
          header="パターン名"></wjrGrid.FlexGridColumn>
        {/* 荷主 */}
        <wjrGrid.FlexGridColumn
          binding="荷主コード"
          width={80}
          header="荷主CD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主略称1"
          width={150}
          header="荷主名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="表紙名"
          width={128}
          dataMap={表紙分割DataMap}
          header="表紙名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地数"
          width={30}
          wordWrap={true}
          header="積地数"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地数"
          width={30}
          wordWrap={true}
          header="卸地数"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="品数"
          width={30}
          wordWrap={true}
          header="品数"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="繰返運行数"
          width={30}
          wordWrap={true}
          header="繰返数"></wjrGrid.FlexGridColumn>
        {/* 積卸地 */}
        <wjrGrid.FlexGridColumn
          binding="積地社名"
          width={150}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地都道府県"
          width={100}
          header="都道府県"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地市区町村"
          width={100}
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地社名"
          width={150}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地都道府県"
          width={100}
          header="都道府県"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地市区町村"
          width={100}
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="輸送備考"
          width={150}
          header="輸送備考"></wjrGrid.FlexGridColumn>
        {/* 品名 */}
        <wjrGrid.FlexGridColumn
          binding="品コード"
          width={80}
          header="CD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="品名"
          width={150}
          header="品名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積載品数量"
          width={64}
          header="数量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="単位区分コード"
          width={64}
          header="単位"
          dataMap={単位区分DataMap}></wjrGrid.FlexGridColumn>
        {/* 車輌 */}
        <wjrGrid.FlexGridColumn
          binding="運行部所コード"
          dataMap={運行部所DataMap}
          header="運行部所"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車番"
          width={80}
          header="車番"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車種区分コード"
          width={130}
          dataMap={車種区分DataMap}
          header="車種"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラ車番"
          width={90}
          header="トレーラ"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="最大積載量"
          dataType={wjCore.DataType.Number}
          header="最大積載量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラ車種区分コード"
          width={130}
          dataMap={車種区分DataMap}
          header="トレ車種"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員名"
          header="運転者"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="食事代"
          header="食事代"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="同乗者1名"
          header="同乗者"></wjrGrid.FlexGridColumn>
        {/* 請求 */}
        <wjrGrid.FlexGridColumn
          binding="荷主請求内訳ID"
          dataMap={請求内訳DataMap}
          header="請求内訳"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求区分コード"
          dataMap={請求区分DataMap}
          header="請求区分"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求数量単価"
          width={100}
          header="請求数量単価"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求車番"
          header="請求車番"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求運送料課税区分コード"
          width={70}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求運送料"
          width={100}
          cssClass="number-col"
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求付帯料課税区分コード"
          width={70}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求付帯料"
          width={100}
          cssClass="number-col"
          header="付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求高速料税込区分名称"
          width={70}
          header="込/抜"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求高速料"
          width={100}
          cssClass="number-col"
          header="高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求合計"
          width={100}
          cssClass="number-col"
          header="請求合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="計上基準日区分名称"
          header="請求基準日"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="date請求計上日"
          format={"d"}
          header="請求計上日"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求備考"
          width={150}
          header="請求備考"></wjrGrid.FlexGridColumn>
        {/* 支払 */}
        <wjrGrid.FlexGridColumn
          binding="支払運送料課税区分コード"
          width={70}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払運送料"
          width={100}
          cssClass="number-col"
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払付帯料課税区分コード"
          width={70}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払付帯料"
          width={100}
          cssClass="number-col"
          header="付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払高速料税込区分名称"
          width={70}
          header="込/抜"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払高速料"
          width={100}
          cssClass="number-col"
          header="高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払合計"
          width={100}
          cssClass="number-col"
          header="支払合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払備考"
          width={150}
          header="支払備考"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
    </div>
  )
}

export default ZyutyuHaisyaPatternModalGrid
